import React from "react";
import Img3 from "../../assets/subscribe-banner 1.png";
import "./Footer.css";
import Grid from "@material-ui/core/Grid";

const Footer = () => {
  return (
    <div className='footer'>
      <div className='first-footer'>
        <Grid container>
          <Grid item xs={12} sm={12} md={6}>
            <div className='first-footer-img'>
              <img src={Img3} alt='img' />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <div className='first-footer-text'>
              <h1>
                Be a member <br /> of our community 🎉
              </h1>
              <p>
                We’d make sure you’re always first to know what’s <br />{" "}
                happening on Vasiti—thus, the world.
              </p>
              <input type='text' placeholder='enter your email address' />
              <button type='submit' className='btn-footer'>
                subscribe
              </button>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className='second-footer'>
        <div className='first-footer-links'>
          <h1>Company</h1>
          <ul>
            <li>About Us</li>
            <li>Terms of Use</li>
            <li>Private Policy</li>
            <li>Press & Media</li>
          </ul>
        </div>

        <div className='first-footer-links'>
          <h1>Products</h1>
          <ul>
            <li>Marketplace</li>
            <li>Magazine</li>
            <li>Seller</li>
            <li>Wholesale</li>
            <li>Services</li>
          </ul>
        </div>

        <div className='first-footer-links'>
          <h1>Careers</h1>
          <ul>
            <li>Become a Campus Rep</li>
            <li>Become a Vasiti Influence</li>
            <li>Become a Campus Writer</li>
            <li>Become a Affiliate</li>
          </ul>
        </div>

        <div className='first-footer-links'>
          <h1>Get in touch</h1>
          <ul>
            <li>Contact us</li>
            <li>Partner with us</li>
            <li>advertise with us</li>
            <li>help/FAQs</li>
          </ul>
        </div>

        <div className='first-footer-links svg'>
          <h1>Join our community</h1>
          <ul>
            <li>
              <svg
                width='7'
                height='12'
                viewBox='0 0 7 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M5.77431 6.69197L6.08204 4.68739H4.15846V3.38655C4.15846 2.83824 4.42708 2.30343 5.28865 2.30343H6.16304V0.596894C6.16304 0.596894 5.36965 0.461548 4.61088 0.461548C3.02688 0.461548 1.99154 1.42178 1.99154 3.15982V4.68774H0.230652V6.69232H1.99154V11.5385H4.15846V6.69232L5.77431 6.69197Z'
                  fill='#25201D'
                />
              </svg>
            </li>
            <li>
              <svg
                width='12'
                height='12'
                viewBox='0 0 12 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M6.38453 0.461548C4.87992 0.461548 4.69207 0.468471 4.1013 0.494779C3.51145 0.522471 3.10992 0.61524 2.75684 0.752317C2.39268 0.893548 2.08345 1.08324 1.77561 1.39109C1.46776 1.69893 1.27761 2.0077 1.13684 2.37232C0.999762 2.72539 0.906531 3.12693 0.8793 3.71678C0.851608 4.30755 0.846069 4.49539 0.846069 6.00001C0.846069 7.50462 0.852992 7.69247 0.8793 8.28324C0.906992 8.87263 0.999762 9.27462 1.13684 9.6277C1.27807 9.99139 1.46776 10.3011 1.77561 10.6089C2.08345 10.9163 2.39222 11.1069 2.75684 11.2477C3.11038 11.3843 3.51192 11.478 4.1013 11.5052C4.69207 11.5329 4.87992 11.5385 6.38453 11.5385C7.88915 11.5385 8.07699 11.5315 8.66776 11.5052C9.25715 11.4775 9.65915 11.3843 10.0122 11.2477C10.3759 11.1065 10.6856 10.9163 10.9935 10.6089C11.3008 10.3011 11.4915 9.99278 11.6322 9.6277C11.7688 9.27462 11.8625 8.87263 11.8898 8.28324C11.9175 7.69247 11.923 7.50462 11.923 6.00001C11.923 4.49539 11.9161 4.30755 11.8898 3.71678C11.8621 3.12739 11.7688 2.72493 11.6322 2.37232C11.491 2.00816 11.3008 1.69893 10.9935 1.39109C10.6856 1.08324 10.3773 0.893086 10.0122 0.752317C9.65915 0.61524 9.25715 0.522009 8.66776 0.494779C8.07699 0.467086 7.88915 0.461548 6.38453 0.461548ZM6.38453 1.45847C7.86284 1.45847 8.03915 1.46586 8.62299 1.49124C9.16299 1.51662 9.45607 1.60616 9.65084 1.68278C9.91022 1.78293 10.0939 1.90293 10.2887 2.09632C10.4821 2.29016 10.6021 2.47432 10.7022 2.7337C10.7779 2.92847 10.8684 3.22155 10.8928 3.76155C10.9191 4.34586 10.9251 4.52124 10.9251 6.00001C10.9251 7.47878 10.9182 7.65462 10.891 8.23847C10.8628 8.77847 10.7728 9.07155 10.6967 9.26632C10.5933 9.5257 10.4756 9.70939 10.2818 9.90416C10.0884 10.0975 9.90145 10.2175 9.64484 10.3177C9.45099 10.3934 9.1533 10.4839 8.6133 10.5083C8.0253 10.5346 7.85222 10.5406 6.37069 10.5406C4.88869 10.5406 4.71561 10.5337 4.12807 10.5065C3.58761 10.4783 3.28992 10.3883 3.09607 10.3122C2.83345 10.2088 2.65299 10.0911 2.45961 9.89724C2.2653 9.70386 2.14115 9.51693 2.04422 9.26032C1.96807 9.06647 1.87853 8.76878 1.85038 8.22878C1.82961 7.64724 1.82222 7.4677 1.82222 5.99309C1.82222 4.51801 1.82961 4.33801 1.85038 3.74955C1.87853 3.20955 1.96807 2.91232 2.04422 2.71847C2.14115 2.45539 2.2653 2.27539 2.45961 2.08109C2.65299 1.8877 2.83345 1.76309 3.09607 1.66662C3.28992 1.59001 3.58115 1.50001 4.12115 1.47232C4.70961 1.45155 4.88269 1.44462 6.36376 1.44462L6.38453 1.45847ZM6.38453 3.15601C4.81299 3.15601 3.54053 4.42986 3.54053 6.00001C3.54053 7.57155 4.81438 8.84401 6.38453 8.84401C7.95607 8.84401 9.22853 7.57016 9.22853 6.00001C9.22853 4.42847 7.95469 3.15601 6.38453 3.15601ZM6.38453 7.84616C5.36453 7.84616 4.53838 7.02001 4.53838 6.00001C4.53838 4.98001 5.36453 4.15386 6.38453 4.15386C7.40453 4.15386 8.23069 4.98001 8.23069 6.00001C8.23069 7.02001 7.40453 7.84616 6.38453 7.84616ZM10.0058 3.04386C10.0058 3.41078 9.70761 3.70847 9.34115 3.70847C8.97423 3.70847 8.67653 3.41032 8.67653 3.04386C8.67653 2.67739 8.97469 2.3797 9.34115 2.3797C9.70715 2.37924 10.0058 2.67739 10.0058 3.04386Z'
                  fill='#25201D'
                />
              </svg>
            </li>
            <li>
              <svg
                width='13'
                height='11'
                viewBox='0 0 13 11'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M12.2072 1.5755C11.7647 1.77491 11.2922 1.91076 10.7947 1.97279C11.3017 1.65957 11.6917 1.1659 11.8762 0.576882C11.4007 0.861395 10.8737 1.0685 10.3127 1.18384C9.86475 0.692225 9.22628 0.384644 8.51731 0.384644C7.15886 0.384644 6.05741 1.51398 6.05741 2.90528C6.05741 3.1052 6.07991 3.29744 6.12091 3.48148C4.07599 3.38254 2.26357 2.37572 1.05062 0.853706C0.837127 1.22383 0.717632 1.65393 0.717632 2.12248C0.717632 2.99909 1.15261 3.76958 1.81159 4.22224C1.4081 4.20891 1.02862 4.09511 0.697632 3.90646V3.93773C0.697632 5.16036 1.5441 6.18 2.67055 6.41222C2.46406 6.46912 2.24607 6.49988 2.02258 6.49988C1.86558 6.49988 1.71509 6.4845 1.5646 6.4558C1.88008 7.45697 2.78705 8.18697 3.8665 8.20747C3.02654 8.88364 1.96208 9.28657 0.815627 9.28657C0.620636 9.28657 0.426144 9.27478 0.230652 9.25223C1.32511 9.96684 2.61455 10.3846 4.00899 10.3846C8.53581 10.3846 11.0082 6.54192 11.0082 3.21491C11.0082 3.10777 11.0082 2.9996 11.0007 2.89195C11.4812 2.53874 11.9007 2.09224 12.2307 1.58575L12.2072 1.5755Z'
                  fill='#25201D'
                />
              </svg>
            </li>
            <li>
              <svg
                width='13'
                height='12'
                viewBox='0 0 13 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M3.24589 11.6154V4.14179H0.761824V11.6154H3.24589ZM2.00418 3.12079C2.87041 3.12079 3.4096 2.54691 3.4096 1.82974C3.39347 1.09641 2.87045 0.538452 2.02061 0.538452C1.17092 0.538452 0.615265 1.09642 0.615265 1.82974C0.615265 2.54694 1.15432 3.12079 1.98796 3.12079H2.0041H2.00418ZM4.62081 11.6154H7.10487V7.44176C7.10487 7.2184 7.12101 6.99526 7.18661 6.83559C7.36619 6.38931 7.77492 5.92709 8.46112 5.92709C9.36 5.92709 9.7196 6.61244 9.7196 7.61712V11.6153H12.2035V7.33004C12.2035 5.03445 10.978 3.96634 9.34364 3.96634C8.00359 3.96634 7.41522 4.71538 7.08835 5.22555H7.10493V4.14164H4.62086C4.65346 4.84292 4.62086 11.6152 4.62086 11.6152L4.62081 11.6154Z'
                  fill='#25201D'
                />
              </svg>
            </li>
          </ul>
          <p>Email newsletter</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
